<h2>Select Your Disposal Destination</h2>
<form [formGroup]="form" class="content-align-left">
  <digital-platform-disposal-site-radio-select
    formControlName="destination"
    type="landfill"
    [asbestosType]="asbestosType"
    [profileStatus]="profileStatus"
    [tabIndex]="tabIndex"
  >
  </digital-platform-disposal-site-radio-select>
  <mat-error *ngIf="hasError('destination', 'required')">
    Disposal Destination is <strong>required</strong>
  </mat-error>
</form>
